'use client';

import { TEST_IDS } from '@repo/sdk/constants';
import { withFieldGroup } from '../../lib/app-form-hook.tsx';
type LocationAddressFieldsProps = {
  disabled?: boolean;
};
type LocationAddressValues = {
  address: string;
  address_second_line: string;
  city: string;
  country: string;
  place_id: null | string;
  place_name: null | string;
  postcode: string;
};
const defaultValues: LocationAddressValues = {
  address: '',
  address_second_line: '',
  city: '',
  country: '',
  place_id: null,
  place_name: null,
  postcode: ''
};
const locationAddressFieldsProps: LocationAddressFieldsProps = {};
export const LocationAddressFields = withFieldGroup({
  defaultValues,
  props: locationAddressFieldsProps,
  render: function Render({
    disabled,
    group
  }) {
    return <section className="flex flex-col gap-6">
        <h3 className="text-2xl font-bold">Address</h3>
        <group.AppField name="address">
          {field => <field.Input data-testid={TEST_IDS.companyLocation.form.addressInput} disabled={disabled} label="Address line 1" placeholder="Some Road" />}
        </group.AppField>
        <group.AppField name="address_second_line">
          {field => <field.Input data-testid={TEST_IDS.companyLocation.form.addressSecondLineInput} disabled={disabled} label="Address line 2" placeholder="Unit 6" />}
        </group.AppField>
        <group.AppField name="postcode">
          {field => <field.Input data-testid={TEST_IDS.companyLocation.form.postcodeInput} disabled={disabled} label="Postal code" placeholder="BS15 9LA" />}
        </group.AppField>
        <group.AppField name="city">
          {field => <field.Input data-testid={TEST_IDS.companyLocation.form.cityInput} disabled={disabled} label="City *" placeholder="Bristol" />}
        </group.AppField>
        <group.AppField name="country">
          {field => <field.FormCountrySelect data-testid={TEST_IDS.companyLocation.form.countrySelect} disabled={disabled} display="name" label="Country *" />}
        </group.AppField>
      </section>;
  }
});